import { render, staticRenderFns } from "./highestQualifications.vue?vue&type=template&id=4620fffe&scoped=true&"
import script from "./highestQualifications.vue?vue&type=script&lang=js&"
export * from "./highestQualifications.vue?vue&type=script&lang=js&"
import style0 from "./highestQualifications.vue?vue&type=style&index=0&id=4620fffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620fffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDialog})
